import React from 'react';

import PropTypes from 'prop-types';
import StrModal from '../../shared/StrModal';
import HeadlineModalTip from './HeadlineModalTip';

const HeadlineModal = props => {
  const suggestions = props.analysis.suggestions.map(suggestion => {
    return <HeadlineModalTip tip={suggestion} />;
  });

  const strengths = props.analysis.strengths.map(strength => {
    return <HeadlineModalTip tip={strength} />;
  });

  return (
    <StrModal
      modalclassNames="export-modal"
      open={props.modalOpen}
      hideModal={props.hideModalHandler}
      title="Headline Writing Tips"
    >
      <div className="tips-modal">
        <h4>Headline Writing tips</h4>
        <div className="headline-summary">
          <div className={`score ${props.scoreClass}`}>
            <div className="number">{props.analysis.overall_score}</div>
            <div className="text">{props.scoreTitle}</div>
          </div>
          <div className="overall-score-summary">
            <h4>Headline Quality score</h4>
            <p>
              Like the lead paragraph in a news story or thesis in an essay,
              your headline is your one true sentence: the single most important
              asset for capturing attention in the feed.
            </p>
          </div>
        </div>
        <div
          className="headline-suggestions"
          ng-show="modalVm.analysis.suggestions"
        >
          <div className="summary-header">Suggestions</div>
          <ul>{suggestions}</ul>
        </div>
        <div
          className="headline-strengths"
          ng-show="modalVm.analysis.strengths"
        >
          <div className="summary-header">Strengths</div>
          <ul>{strengths}</ul>
        </div>
      </div>
    </StrModal>
  );
};

HeadlineModal.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  hideModalHandler: PropTypes.func.isRequired,
  analysis: PropTypes.object.isRequired,
  scoreTitle: PropTypes.string.isRequired,
  scoreClass: PropTypes.string.isRequired
};

export default HeadlineModal;
